import FooterLogo from "./icons/Footerlogo";
import "./styles/Footer.css";

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-logo">
        <a
          href="https://www.astranahealth.com/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FooterLogo />
        </a>
      </div>
    </footer>
  );
}

export default Footer;
